<template>
    <div>
        <Toolbar>
            <BackButton/>
        </Toolbar>

        <Card>
            <template v-slot:title>
                {{ __('actions.edit_thing', {thing: __('general.pricing_model')}) }}
            </template>
            <template v-slot:description>
                {{ productable.name }}
            </template>
            <template v-slot:default>
                <div v-for="pricingGroup in pricingGroups"
                     class="row mb-5"
                     :class="{
                        'border-top border-light-light mt-5 pt-10': pricingGroup !== 'all',
                    }">
                    <div class="col-md-3 text-right">
                        <div class="font-weight-bold font-size-lg text-uppercase">
                            {{ pricingGroup }}
                        </div>
                        <div class="text-muted">
                            {{ __('subscriptions.pricing_groups.' + pricingGroup) }}
                        </div>
                    </div>
                    <div class="col">
                        <div v-if="productable.pricing_groups.hasOwnProperty(pricingGroup)">
                            <PricingForm v-for="pricing in productable.pricing_groups[pricingGroup]"
                                         :key="pricing.id"
                                         :value="pricing"
                            />
                        </div>
                        <div v-else class="font-weight-light text-muted mb-3">
                            Noch keine Preise definiert.
                        </div>
                        <button class="btn btn-xs btn-light-primary">
                            <i class="fas fa-plus-square"/>
                            Preis hinzufügen
                        </button>
                    </div>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import PricingForm from "@components/Subscriptions/Pricing/PricingForm.vue";

export default {
    components: {PricingForm, BackButton, Toolbar, Card},

    props: {
        productable: Object
    },

    data() {
        return {
            pricingGroups: ['all', 'flex', 'fixed']
        }
    }
}
</script>
